import { render, staticRenderFns } from "./ContractItemsList.vue?vue&type=template&id=673d1a81&scoped=true"
import script from "./ContractItemsList.vue?vue&type=script&lang=js"
export * from "./ContractItemsList.vue?vue&type=script&lang=js"
import style0 from "./ContractItemsList.vue?vue&type=style&index=0&id=673d1a81&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "673d1a81",
  null
  
)

export default component.exports